import React from 'react';
import {ReportingBaseFilter} from './base-filter';
import {BaseFilterProps} from './interface';

interface ActionItemsFilterProps extends BaseFilterProps {}

export const ReportingActionItemsFilter = (props: ActionItemsFilterProps) => {
  return <ReportingBaseFilter {...props}></ReportingBaseFilter>;
};
